import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { Options } from './types';

const common = ['US', 'CA', 'GB', 'AU'];
const countries = getCountries();

const countrySorter = (a: string, b: string, arr: string[]) => {
  if (arr.includes(a)) {
    return -1;
  }
  if (arr.includes(b)) {
    return 1;
  }
  return a.localeCompare(b);
};

const getCountriesData = (): Options[] => {
  const displayCountryNames = new Intl.DisplayNames('en', { type: 'region' });

  return countries
    .sort((a, b) => countrySorter(a, b, common))
    .map((country) => {
      const countryCode = getCountryCallingCode(country);
      const fullCountryName = displayCountryNames.of(country);

      return {
        value: country,
        name: fullCountryName,
        label: `${fullCountryName} (+${countryCode})`,
        flag: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`,
        countryCode,
      };
    });
};

export const countriesData = getCountriesData();

export const defaultCountry = countriesData.find((c) => c.value === 'US')!;

export const getCountryDetailsForCode = (code: string) => countriesData.find((c) => c.countryCode === code);

export const getCurrentUserCountry = (shortCountryName: CountryCode): Options => {
  const displayCountryNames = new Intl.DisplayNames('en', { type: 'region' });
  const countryPhoneCode = getCountryCallingCode(shortCountryName);
  return {
    value: shortCountryName,
    label: `${displayCountryNames.of(shortCountryName)} (+${getCountryCallingCode(shortCountryName)})`,
    flag: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${shortCountryName}.svg`,
    countryCode: countryPhoneCode,
  };
};
